import React, { useMemo, useState } from "react";
import { CustomCheckbox } from "../../constants/customComponent/CustomCheckbox";
import { Button, FormControlLabel, Collapse } from "@material-ui/core";
import { useSalesOrder } from "../../context/SalesOrderContext";
import PropTypes from 'prop-types';
const SelectUnit = () => {
  const [isCheckedMessage, setCheckedMessage] = useState(false);
  const [openIndex, setOpenIndex] = useState(null); // <- índice del item abierto (o null)
const [idBox, setIdBox] = useState({isChecked:false, id:null})
    const {expanded, onClick, toggleModal}=useSalesOrder()
  // dummy 8 items solo para demo
  const items = useMemo(() => Array.from({ length: 8 }), []);

  return (
    <div>
      <h5>
        Sleccione Unidad <i className="fas fa-angle-down ms-2 mt-2" />
      </h5>

      <Collapse in={expanded} timeout={200} unmountOnExit>
        <div
          className="p-2"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "0.75rem",
            height: "280px",
            overflowY: "auto",
          }}
        >
          {items.map((_, i) => (
            <UnitItem
              key={i}
              id={i+1}
              idBox={idBox}
              setIdBox={setIdBox}
              open={openIndex === i}
              onToggle={() => setOpenIndex((prev) => (prev === i ? null : i))} 
            />
          ))}
        </div>

        <div className="d-flex flex-column align-items-end">
          <div className="d-flex align-items-center">
            <FormControlLabel
              control={
                <CustomCheckbox
                  color="primary"
                  size="small"
                  className="ms-2"
                  onChange={() => setCheckedMessage((prev) => !prev)}
                  checked={isCheckedMessage}
                />
              }
              label={<span className="text-danger mt-3">*Pedido será confirmado para CFPVMCP</span>}
            />
          </div>
          <div className="d-flex justify-content-end gap-2">
            <Button color="primary" onClick={onClick} disabled={!isCheckedMessage || !idBox.id}>
              Confirmar
            </Button>
            <Button color="secondary" aria-expanded={expanded} aria-controls="order-collapse" onClick={()=>toggleModal()}>
              Cancelar
            </Button>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

// UnitItem ahora es CONTROLADO: no guarda estado interno de showMore
const UnitItem =({ open, onToggle,id, setIdBox, idBox }) =>{
      // const [showMore, setShowMore] = useState(false);
      
      const onChangeChecked = ()=>{

        setIdBox((prev)=>({
          ...prev, isChecked:!prev.isChecked, id
        }))
      }
  return (
    <div className="d-flex align-items-start gap-2 p-1">
         <FormControlLabel
                            control={
                                <CustomCheckbox
                                color="primary"
                                size="small"
                                className="ms-2"  
                                onChange={onChangeChecked}
                                checked={idBox?.id === id  }       
                                />}/>

      <div className="small lh-1">
        <div className="mb-1">
          <span className="text-muted me-1">Transportista:</span>
          <span>Cmenterotoososo</span>
        </div>
        <div className="mb-1">
          <span className="text-muted me-1">Placas:</span>
          <span>123-4232-2</span>
        </div>

        {open ? (
          <>
            <div className="mb-1">
              <span className="text-muted me-1">Config. Vehicular:</span>
              <span>Avbc-33eas</span>
            </div>
            <div className="mb-1">
              <span className="text-muted me-1">Año Modelo:</span>
              <span>2024</span>
            </div>
            <div className="mb-1">
              <span className="text-muted me-1">Nombre Transportista:</span>
              <span>Albertano dkkre sdasd</span>
            </div>
            <Button onClick={onToggle} className="p-0" size="small" color="primary">
              <span className="small">mostrar menos</span>
            </Button>
          </>
        ) : (
          <Button onClick={onToggle} className="p-0" size="small" color="primary">
            <span className="small">mostrar más…</span>
          </Button>
        )}
      </div>
    </div>
  );
};

UnitItem.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,

  setIdBox: PropTypes.func.isRequired,

  idBox: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    isChecked: PropTypes.bool,
  }),
};
export default SelectUnit;
